var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTextBold = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 2, d: "M5.063 8.438H10.5a3.19 3.19 0 0 1 3.188 3.187 3.19 3.19 0 0 1-3.188 3.188H5.063zm0-5.25h4.939c1.588 0 2.88 1.177 2.88 2.625s-1.292 2.625-2.88 2.625h-4.94z" }) }))); };
export default SvgTextBold;
